import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7a836bca&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=7a836bca&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a836bca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a836bca')) {
      api.createRecord('7a836bca', component.options)
    } else {
      api.reload('7a836bca', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=7a836bca&scoped=true", function () {
      api.rerender('7a836bca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/csgOrder/feeInfoTab/index.vue"
export default component.exports